import { AppRoute } from '@agentselly/immodossier-shared';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslate } from '@tolgee/react';
import { useV3Redesign } from '~/helper/useV3Redesign';
import { RenderWidgets } from '~/components/widget/RenderWidgets';

export const Route = createFileRoute<any, any, any, any>(
  AppRoute.$LANG_$COMPANYID_PUBLIC_CONTACT,
)({
  component: function Body() {
    const v3 = useV3Redesign();
    const { t } = useTranslate();
    const widgets = [
      {
        name: 'hubspotForm',
        cols: 4,
        props: {
          // Brand-neutral heading (no "AgentSelly"). New Tolgee key with a
          // German default fallback so it renders correctly even before the
          // translation is added remotely.
          title: 'contact_form_title_neutral',
          titleDefault: 'Nachricht an uns',
          description: 'contact_form_text',
          portalId: '26776524',
          formId: '9e9d404c-4901-450d-b9bb-3fea2f96c6cf',
          guestFormId: '0bb35717-a8d8-4bc8-a9c4-98f36c2039d4',
          bookingUrl:
            'https://meetings-eu1.hubspot.com/martin-heim/15-min-meeting-kostenlose-beratung-',
        },
      },
    ];
    if (!v3) return <RenderWidgets widgets={widgets} />;
    return (
      <div className="v3p-page">
        <div
          className="v3-head"
          data-od-id="page-head"
        >
          <h1>{t('v3_contact_title', 'Kontakt')}</h1>
          <p>
            {t(
              'v3_contact_subtitle',
              'Wir helfen Ihnen gern, mit oder ohne Konto.',
            )}
          </p>
        </div>
        <div data-od-id="contact-form">
          <RenderWidgets widgets={widgets} />
        </div>
      </div>
    );
  },
});
